export const hasDataToRender = (data?: Record<string, any>[]) =>
  (Boolean(data?.length) && data?.some((item) => Object.values(item).some((value) => value !== ''))) ?? false;
